import React from 'react'
import { Grid, Card, Typography } from '@mui/material'
import { connect } from 'react-redux'
import IntlMessages from '../../../util/IntlMessages'
import * as tools from '../../../util/tools'
import useStyles from './styles'

function Organization(props) {
    const classes = useStyles()

    const getClassesRoot = () => {
        switch (props.type) {
            case 'organization':
                return classes.gridTopOrganization
            case 'local':
                return classes.gridTopLocal
            default:
                return classes.gridTopOnline
        }
    }

    let data = tools.fuelRequestComponentFormatData(props)

    return (
        <Card className={classes.root}>
            <Grid container className={getClassesRoot()}>
                <Grid item xs={6} md={6} >
                    <Typography variant="body1" className={classes.textTopRight}>
                        {data.dtAddAt}
                    </Typography>
                </Grid>
                <Grid item xs={6} md={6}>
                    <Typography variant="body1" className={classes.textTopLeft}>
                        {data.vRequestCode}
                    </Typography>
                </Grid>
            </Grid>
            <Grid container className={classes.gridBottom}>
                <Grid item xs={9} md={9}>
                    <Typography variant="body1">
                        {data.vMessage}
                    </Typography>
                </Grid>
                <Grid item xs={3} md={3}>
                    <Typography variant="body1" className={classes.gridBottomText}>
                        <span className={classes.literText}>
                            {data.iVolume}
                        </span>
                        <IntlMessages id="liter" />
                    </Typography>
                </Grid>
            </Grid>
        </Card>
    )
}

export default connect()(Organization)
